import { Directive, ElementRef, Input, AfterViewInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appChipListA11yFix]'
})
export class ChipListA11yFixDirective implements AfterViewInit, OnDestroy {
  @Input('appChipListA11yFix') dynamicLabel: string = '';

  private observer: MutationObserver;

  constructor(private el: ElementRef<HTMLElement>) { }

  ngAfterViewInit(): void {
    this.applyAccessibilityFix();

    this.observer = new MutationObserver(() => {
      this.applyAccessibilityFix();
    });

    this.observer.observe(this.el.nativeElement, {
      childList: true,
      subtree: true,
    });
  }

  private applyAccessibilityFix(): void {
    const chipList = this.el.nativeElement;
    const hasChips = chipList.querySelectorAll('mat-chip').length > 0;
    console.log('hasChips =====>', hasChips);

    if (hasChips) {
      chipList.setAttribute('role', 'listbox');
      chipList.setAttribute('aria-orientation', 'horizontal');
      if (this.dynamicLabel) {
        chipList.setAttribute('aria-label', this.dynamicLabel);
      }
    } else {
      chipList.setAttribute('role', 'presentation');
      chipList.removeAttribute('aria-multiselectable');
      chipList.removeAttribute('aria-orientation');
      chipList.removeAttribute('aria-label');
    }
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
